import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import categoryIcon from "../../assets/images/icons/round_icon.svg";
import autodukan_logo from "../../assets/images/autoducan_logo.png";
import rcverify from "../../assets/images/rcverify.png";
import challan from "../../assets/images/challan.png";
import fasttag from "../../assets/images/fasttag-autodukan.jpg";
import car_garage from "../../assets/images/car.png";
import car_wash from "../../assets/images/car-wash.png";
import tow_truck from "../../assets/images/tow-truck.png";
import evcharging from "../../assets/images/charging-station.png";
import petrol_pump from "../../assets/images/petrol-pump.png";
import puc from "../../assets/images/electric-vehicle.png";
import insurance from "../../assets/images/protection.png";
import { useTheme } from '@mui/material/styles';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import mk2 from "../../assets/images/mk2.png";
import mk3 from "../../assets/images/mk3.png";
import dots from "../../assets/images/dots.png";

const HomeSection3 = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const serviceItems = [
    { title: "PUC Info", route: "/puc-info", image: puc },
    { title: "Car Info", route: "/car-info", image: rcverify },
    { title: "Garages", route: "/garages-info", image: car_garage },
    { title: "Washing Center", route: "/washing-info", image: car_wash },
    { title: "Towing", route: "/towing-info", image: tow_truck },
    { title: "Petrol Pump", route: "/petrolStation-info", image: petrol_pump },
    { title: "EV Station", route: "/evStation-info", image: evcharging },
    { title: "Insurance Info", route: "/ins-inf", image: insurance },
  ];

  return (
    <>
      <Box
        // height={{ lg: "274px", md: "350px" }}
        alignContent={"center"}
        sx={{
          paddingTop: { lg: "80px", xs: "50px" },
          pb: { lg: "80px", xs: "50px" },
          // padding: { lg: "84px 121px 102px 125px", md: "45px 56px 100px 56px", xs: "20px" }, // Set padding only for lg screen
          // [theme.breakpoints.down('xs')]: {
          //   padding: 0,
          // },
          backgroundColor: "rgba(246, 246, 246, 1)",
        }}
      >

        <Grid
          fluid="true"
          maxWidth={{ xl: "1303px", lg: "1103px", xs: undefined, md: "900px", sm: "800px" }}
          margin="auto"
          sx={{
            padding: { lg: "0px", md: "0px", sm: "10px", xs: "10px" }
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: { lg: "0px", md: "29px", xs: "0px" },
              alignItems: "center",
            }}
          >
            <Box display={"flex"}>
              <h2
                className="title_name1"
                style={{
                  margin: "0px",
                  // fontSize: { lg: "35px", xs: "28px" },
                  textTransform: "uppercase",
                  borderRadius: "10px",
                  fontWeight: 500,
                  lineHeight: "30px",
                  fontFamily: "'Bebas Neue', sans-serif"
                }}
              >
                Our Services
              </h2>
            </Box>
            <Box>
              <Link to={"/services"}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardOutlinedIcon style={{ fontSize: '15px' }} />}
                  sx={{
                    backgroundColor: "rgba(255, 102, 51, 1)",
                    fontFamily: "'Barlow', sans-serif",
                    textTransform: "none",
                    borderRadius: "5px",
                    width: { lg: "129px", xs: "110px", sm: "121px", md: "121px" },
                    fontSize: { lg: "19px", xs: "17px", sm: "19px", md: "19px" },
                    height: { lg: "41px", xs: "30px", sm: "33px", md: "35px" },
                    "&:hover": {
                      backgroundColor: "rgba(255, 102, 51, 1)",
                      color: "#fff",
                    },
                  }}
                >
                  View All
                </Button>
              </Link>
            </Box>
          </Box>

          <Box mt={3} sx={{ display: { xs: 'block', lg: 'none' }, overflowX: 'auto' }}>
            <Grid container spacing={2} justifyContent="flex-start" sx={{ display: 'flex', flexWrap: 'nowrap' }}>
              {serviceItems.map((item, index) => (
                <Grid key={index} item>
                  <Box
                    className="homesection2_service-box"
                    onClick={() => navigate(item.route)}
                    sx={{
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center', // Align items in center
                      gap: { lg: '20px', xs: '10px', md: '20px' },
                      paddingLeft: { lg: '24px', md: '24px', xs: '10px' },
                    }}
                  >
                    <img
                      loading="lazy"
                      src={item.image}
                      style={{ width: '70px', height: 'auto' }}
                    />
                    <h3
                      style={{
                        margin: "0px",
                        fontFamily: "'Bebas Neue', sans-serif",
                        fontSize: "22px",
                        fontWeight: 500
                      }}
                    >
                      {item.title}
                    </h3>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
          {/* Render first four items in one row for large screens */}
          <Grid container spacing={2} justifyContent="center" mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
            {serviceItems.slice(0, 4).map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={3}>
                <Box
                  className="homesection2_service-box"
                  onClick={() => navigate(item.route)}
                  sx={{
                    padding: "10px",
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: { lg: '20px', xs: "10px", md: "20px" }, paddingLeft: { lg: '24px', md: '24px', xs: '10px' } }}>
                    <img
                      loading="lazy"
                      src={item.image}
                      alt={`${item.title}`}
                      style={{ width: "70px" }}
                    />
                    <h3
                      style={{
                        margin: "0px",
                        fontFamily: "'Bebas Neue', sans-serif",
                        fontSize: "22px",
                        fontWeight: 500
                      }}
                    >
                      {item.title}
                    </h3>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Render remaining items in the next row for large screens */}
          <Grid container spacing={2} justifyContent="center" mt={1} sx={{ display: { xs: 'none', lg: 'flex' } }}>
            {serviceItems.slice(4).map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={3}>
                <Box
                  className="homesection2_service-box"
                  onClick={() => navigate(item.route)}
                  sx={{
                    padding: "10px",
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: { lg: '20px', xs: "10px", md: "20px" }, paddingLeft: { lg: '24px', md: '24px', xs: '10px' } }}>
                    <img
                      loading="lazy"
                      alt={`${item.title}`}
                      src={item.image}
                      style={{ width: "70px" }}
                    />
                    <h3
                      style={{
                        margin: "0px",
                        fontFamily: "'Bebas Neue', sans-serif",
                        fontSize: "22px",
                        fontWeight: 500
                      }}
                    >
                      {item.title}
                    </h3>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

        </Grid>
      </Box >
    </>
  );
};

export default HomeSection3;
